'use client';

// Host storage adapter for @aumonline/light-accounts.
import { api } from "./api";

const unwrap = async (p) => (await p).data;

export const createAccountsStorage = () => ({
  listAccounts: (params) => unwrap(api.get("/accounts", { params })),
  createAccount: (body) => unwrap(api.post("/accounts", body)),
  updateAccount: (id, body) => unwrap(api.put(`/accounts/${id}`, body)),
  deleteAccount: (id) => unwrap(api.delete(`/accounts/${id}`)),
});
